import React from "react";
import logo from "./../logo.svg";
import "./../App.css";

function AvisoPrivacidad() {
  return (
    <div className="content">
      <h1>Aviso de Privacidad</h1>
      <p>
        <strong>Última actualización:</strong> 29 de enero de 2025
        <strong> A chelear </strong> (en adelante, "la Aplicación") es un
        servicio desarrollado por<strong> A chelear</strong>, Nos comprometemos
        a proteger la privacidad de nuestros usuarios y garantizar la seguridad
        de sus datos personales. Este Aviso de Privacidad explica cómo
        recopilamos, utilizamos y protegemos la información relacionada con la
        ubicación de su dispositivo móvil cuando usa nuestra Aplicación en{" "}
        <strong>Android e iOS.</strong>
      </p>
      <p>
        La Aplicación solicita acceso a la{" "}
        <strong>ubicación del dispositivo móvil</strong> para brindar ciertas
        funcionalidades. Dependiendo de la configuración del usuario, podemos
        recopilar:
        <br />
        &#8226;{" "}
        <strong>
          Ubicación en tiempo real (GPS, Wi-Fi y redes móviles):
        </strong>{" "}
        Para ofrecer servicios basados en la ubicación. <br />
        &#8226;{" "}
        <strong>
          Ubicación en segundo plano (si el usuario lo autoriza):
        </strong>{" "}
        Para mejorar la experiencia de uso sin necesidad de que la aplicación
        esté abierta.
        <br />
        No recopilamos otros datos personales sin su consentimiento explícito.
      </p>
      <p>
        Utilizamos la ubicación del usuario exclusivamente para:
        <br />✅{" "}
        <strong>
          Mostrar las tiendas de venta de bebidas y comida cercanas a su
          ubicación.
        </strong>
        <br />
        La ubicación NO se usará para publicidad dirigida sin el consentimiento
        del usuario.
      </p>
      <p>
        La ubicación del usuario NO será vendida, alquilada ni compartida con
        terceros, salvo en los siguientes casos:
        <br />
        &#8226; <strong>Proveedores de servicios tecnológicos </strong>que nos
        ayuden a mejorar la Aplicación (bajo estrictas medidas de seguridad).
        <br />
        &#8226; <strong> Requerimientos legales: </strong>Si es necesario por
        orden judicial o para cumplir con regulaciones aplicables.
      </p>
      <p>
        El usuario puede gestionar los permisos de ubicación en cualquier
        momento desde la configuración de su dispositivo:
        <br />
        📌 <strong>Android:</strong> Ajustes → Aplicaciones → A chelear →
        Permisos → Ubicación <br /> 📌 <strong>iOS:</strong> Configuración →
        Privacidad → Servicios de Ubicación → A chelear
        <br />
        Si el usuario desactiva el acceso a la ubicación, algunas funciones de
        la Aplicación pueden verse limitadas.
      </p>
      <p>
        Implementamos medidas de seguridad para proteger la información de
        ubicación contra accesos no autorizados, pérdida o alteración. Sin
        embargo, ningún sistema es completamente infalible, por lo que
        recomendamos a los usuarios mantener su dispositivo seguro.
      </p>
      <p>
        Nos reservamos el derecho de modificar este Aviso de Privacidad en
        cualquier momento. Cualquier cambio será notificado a través de la
        Aplicación o nuestro sitio web.
      </p>
      <p>
        Si tienes dudas sobre este Aviso de Privacidad o deseas ejercer tus
        derechos de acceso, rectificación o eliminación de datos, contáctanos
        en:
        <br />
        📧 <strong>administrador@achelear.com </strong> <br />
        🌐 <a href="https://achelear.com.mx/">https://achelear.com.mx/ </a>
      </p>
      <footer>
        <p>© 2024 A chelear. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}

export default AvisoPrivacidad;
